import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: "/media/avatars/blank.png",
  alt: ""
}
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_9 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = { class: "menu-item px-5" }
const _hoisted_13 = { class: "menu-item px-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_15 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.user.avatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.site_url +'/'+ _ctx.user.avatar,
                alt: ""
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.first_name+ ' ' + _ctx.user.last_name), 1),
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.user.email), 1)
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: { name: 'profile-overview', params: {  } },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('my_profile')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: { name: 'my-orders', params: {  } },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('my_orders')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        to: { name: 'wishlist', params: {  } },
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('my_wishlist')), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t('logOut')), 1)
    ])
  ]))
}